import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CalendarModule, PaginatorModule, TabViewModule, TooltipModule } from 'primeng';
import { VmePipesModule } from '../../../vme-pipes.module';
import { WarningContainerComponent } from '../../create-movement-job/warning-container/warning-container.component';
import { addHours } from '../../../utils/date-utils';
import { add } from 'date-fns';

@Component({
  selector: 'app-date-time-selector',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule,
    PaginatorModule,
    TabViewModule,
    TooltipModule,
    VmePipesModule,
    WarningContainerComponent,
  ],
  templateUrl: './date-time-selector.component.html',
  styleUrls: ['./date-time-selector.component.css'],
})
export class DateTimeSelectorComponent implements OnInit, OnChanges {
  @Input() pickupDateTime: Date;
  @Input() dropoffDateTime: Date;

  @Input() customerEarliestPickup: Date;
  @Input() customerLatestPickup: Date;

  @Input() customerEarliestDropoff: Date;
  @Input() customerLatestDropoff: Date;

  @Output() pickupDateTimeChange = new EventEmitter<Date>();
  @Output() dropoffDateTimeChange = new EventEmitter<Date>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['pickupDateTime']) {
      this.pickupDateTime = this.ensureDate(this.pickupDateTime);
    }

    if (changes['dropoffDateTime']) {
      this.dropoffDateTime = this.ensureDate(this.dropoffDateTime);
    }

    if (changes['customerEarliestPickup']) {
      this.customerEarliestPickup = this.ensureDate(this.customerEarliestPickup);
    }

    if (changes['customerLatestPickup']) {
      this.customerLatestPickup = this.ensureDate(this.customerLatestPickup);
    }

    if (changes['customerEarliestDropoff']) {
      this.customerEarliestDropoff = this.ensureDate(this.customerEarliestDropoff);
    }

    if (changes['customerLatestDropoff']) {
      this.customerLatestDropoff = this.ensureDate(this.customerLatestDropoff);
    }

    this.checkIfOutsideCustomerWindow();
  }

  private ensureDate(value: any): Date {
    return value instanceof Date ? value : new Date(value);
  }

  protected activeTab = 0;

  constructor() {}

  ngOnInit(): void {}

  onPickupChange(value: Date) {
    this.pickupDateTimeChange.emit(value);
    this.checkIfOutsideCustomerWindow();
  }

  onDropoffChange(value: Date) {
    this.dropoffDateTimeChange.emit(value);
    this.checkIfOutsideCustomerWindow();
  }

  checkIfOutsideCustomerWindow() {
    this.isOutsideCustomerWindow =
      this.pickupDateTime < this.customerEarliestPickup ||
      addHours(this.pickupDateTime, 1) > this.customerLatestPickup ||
      this.dropoffDateTime < this.customerEarliestDropoff ||
      addHours(this.dropoffDateTime, 1) > this.customerLatestDropoff;
  }

  isOutsideCustomerWindow = false;
  protected readonly add = add;
  protected readonly addHours = addHours;
}
